import { render } from "./new.vue?vue&type=template&id=247ac98c&scoped=true&ts=true"
import script from "./new.vue?vue&type=script&lang=ts"
export * from "./new.vue?vue&type=script&lang=ts"

import "./new.vue?vue&type=style&index=0&id=247ac98c&lang=less&scoped=true"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247ac98c"]])

export default __exports__